import axios from 'axios';
import { baseOrigin,baseOrigin2 } from 'config';
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
    response => {
        if (response.data.code === 401) {
            localStorage.setItem('token', '');
            window.location.href = '/login';
            console.warn('登录超时，请重新登录');
        }
        return response
    },
    error => {
        if (error.response && error.response.status === 401) {
            localStorage.setItem('token', '');
            window.location.href = '/login';
            console.warn('登录超时，请重新登录');
        }
        // 处理其他错误
        if (error.response && error.response.status === 500) {
            console.error('服务器内部错误，请联系管理员');
        }
        return Promise.reject(error);
    }
);

const defaultLine = {
    route: 'Line1',
    name: 'line1',
    url: `${baseOrigin}`,
    success: false,
    time: 0
};

// 统一管理多个URL
const URLs =
    [
        {
            route: 'Line1',
            test: 'test1',
            name: 'line1',
            url: `${baseOrigin}`,
        },
        {
            route: 'Line2',
            test: 'test2',
            name: 'line2',
            url: `${baseOrigin2}`,
        },
    ]
// 初始化网络环境
export const networkInit = async (init = true, network) => {
    const tryLine = async (line) => {
        try {
            let localTime = Date.now();
            let res = await axios.get(`${line.url}/user/check_line`);
            const responseData = await res.data;
            if (responseData.code === 200) {
                let serverTime = responseData.data;
                line.success = true;
                line.time = serverTime - localTime;
            } else {
                console.error(`${line.route} 线路连接失败`);
                line.time = 0;
                line.success = false;
            }
        } catch (e) {
            console.error(`${line.route} 线路连接失败`);
            line.time = 0;
            line.success = false;
        }
    };

    if (!network || init) {
        let lines = [];
        for (const line of URLs) {
            await tryLine(line);
            lines.push(line);
        }

        // 筛选出成功且延迟最低的线路
        const successfulLines = lines.filter(line => line.success);
        let bestLine = null;
        if (successfulLines.length > 0) {
            // 如果有成功的，取延迟最低的
            bestLine = successfulLines.reduce((minLine, line) =>
                (line.time < minLine.time ? line : minLine), successfulLines[0]);
        } else {
            // --- 关键改动：如果没有成功的线路，使用默认线路 ---
            console.warn("所有线路探测失败，正在使用默认线路");
            bestLine = defaultLine;
        }

        // 存入 sessionStorage
        sessionStorage.setItem('network', JSON.stringify(bestLine));
    }
};


// 获取基础的 URI 地址
export const getBaseURL = async () => {
    const localNetwork = sessionStorage.getItem('network');
    let network = localNetwork !== 'undefined' ? JSON.parse(localNetwork) : null;
    if (!network) {
        await networkInit();
        network = JSON.parse(sessionStorage.getItem('network'));
    }
    return network.url;
};

// 基础的 axios 请求方法
export const bvaRequest = async (url, method = 'GET', data = {}, config = {}) => {
    const baseURL = await getBaseURL();
    try {
        return await axiosInstance({
            method,
            url: baseURL + url,
            data,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token'),
                ...config.headers,
            },
            ...config,
        });
    } catch (error) {
        // 错误处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    console.warn('登录超时，请重新登录');
                    localStorage.setItem('token', '');
                    window.location.href = '/login';
                    break;
                case 500:
                    console.error('服务器内部错误，请联系管理员');
                    break;
                default:
                    console.error('请求失败：', error.response.status, error.response.data);
                    break;
            }
        } else {
            console.log(error);
        }
        if (error.message === 'Network Error') {
            error.message = '当前您的状态可能打开的VPN/代理，可能无法正常获取通讯数据，若未打开，请刷新页面或者重新打开浏览器';
        }
        throw error;
    }
};

// export const baseRequst = async (
//     url, 
//     method = 'GET', 
//     data = {}, 
//     config = {},
//     customBaseURL
// ) => {
//     // const baseURL = await getBaseURL();
//     const baseURL = customBaseURL || await getBaseURL();
//     const axiosConfig = {
//         method,
//         url: baseURL + url,
//         headers: {
//             'Content-Type': 'application/json',
//             'Authorization': localStorage.getItem('token'),
//             ...config.headers,
//         },
//         ...config,
//     };

//     if (data !== null && Object.keys(data).length > 0) {
//         axiosConfig.data = data;
//     } else {
//         delete axiosConfig.data;
//     }
//     try {
//         return await axios(axiosConfig);
//     } catch (error) {
//         // 错误处理
//         if (error.response) {
//             switch (error.response.status) {
//                 case 401:
//                     localStorage.setItem('token', '');
//                     window.location.href = '/login';
//                     console.warn('登录超时，请重新登录');
//                     break;
//                 case 500:
//                     console.error('服务器内部错误，请联系管理员');
//                     break;
//                 default:
//                     console.error('请求失败：', error.response.status, error.response.data);
//                     break;
//             }
//         } else {
//             console.error('请求失败：', error.message);
//         }
//         throw error;
//     }
// };

// 文件上传 axios 请求方法

export const baseRequst = async (
    url,
    method = 'GET',
    data = {},
    config = {},
    customBaseURL
) => {

    const baseURL = customBaseURL || await getBaseURL();

    const axiosConfig = {
        method,
        url: baseURL + url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('token'),
            ...config.headers,
        },
        ...config,
    };

    // GET 用 params
    if (method.toUpperCase() === 'GET') {

        axiosConfig.params = data;

    } else {

        if (data !== null && Object.keys(data).length > 0) {
            axiosConfig.data = data;
        }

    }

    try {

        return await axiosInstance(axiosConfig);

    } catch (error) {

        if (error.response) {

            switch (error.response.status) {

                case 401:
                    localStorage.setItem('token', '');
                    window.location.href = '/login';
                    console.warn('登录超时，请重新登录');
                    break;

                case 403:
                    console.warn('暂无权限访问');
                    break;

                case 500:
                    console.error('服务器内部错误');
                    break;

                default:
                    console.error(
                        '请求失败：',
                        error.response.status,
                        error.response.data
                    );
                    break;
            }

        } else {
            console.error('请求失败：', error.message);
        }

        throw error;
    }
};

export const fileRequest = async (url, method = 'POST', data = {}, config = {}) => {
    const baseURL = await getBaseURL();
    try {
        return await axiosInstance({
            method,
            url: baseURL + url,
            data,
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': localStorage.getItem('token'),
                ...config.headers,
            },
            ...config,
        });
    } catch (error) {
        // 错误处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    console.warn('登录超时，请重新登录');
                    localStorage.setItem('token', '');
                    window.location.href = '/login';
                    break;
                case 413:
                    console.error('上传的文件过大，请选择较小的文件进行上传。');
                    break;
                case 500:
                    console.error('服务器内部错误，请联系管理员');
                    break;
                default:
                    console.error('请求失败：', error.response.status, error.response.data);
                    break;
            }
        } else {
            console.log(error);
        }
        if (error.message === 'Network Error') {
            error.message = '当前您的状态可能打开的VPN/代理，可能无法正常获取通讯数据，若未打开，请刷新页面或者重新打开浏览器';
        }
        throw error;
    }
};

// 管理临时接口 axios 请求方法
export const tempRequest = async (url, method = 'GET', data = {}, config = {}) => {
    const baseURL = await getBaseURL();
    try {
        return await axiosInstance({
            method,
            url: baseURL + url,
            data,
            headers: {
                'Content-Type': 'application/json',
                'authorization': localStorage.getItem('token'),
                ...config.headers,
            },
            ...config,
        });
    } catch (error) {
        // 错误处理
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    window.location.href = '/login';
                    localStorage.setItem('token', '');
                    console.warn('登录超时，请重新登录');
                    break;
                case 500:
                    console.error('服务器内部错误，请联系管理员');
                    break;
                default:
                    console.error('请求失败：', error.response.status, error.response.data);
                    break;
            }
        } else {
            console.log(error);
        }
        if (error.message === 'Network Error') {
            error.message = '当前您的状态可能打开的VPN/代理，可能无法正常获取通讯数据，若未打开，请刷新页面或者重新打开浏览器';
        }
        throw error;
    }
};


export const baseURL = baseOrigin;
